(function () {
    'use strict';

    angular.module("imApp").factory("gisPositionService", ['$ihttp', function ($ihttp) {
        let service = {
            getLocation: function (parms) {
                return $ihttp.post({
                    method: 1286,
                    parameters: parms || {}
                });
            },
            saveObj: function (location) {
                return $ihttp.post({
                    method: 1287,
                    parameters: location
                });
            },
            deleteItem: function (location) {
                return $ihttp.post({
                    method: 1288,
                    parameters: location
                });
            }
        };

        return service;
    }]);
})();
